import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { GET_ONE, UPDATE } from 'react-admin';
import {
  FormHelperText,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  Input,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  FormControl,
  FormControlLabel,
  Grid,
  Snackbar,
  IconButton,
  Switch,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import AssessmentIcon from '@material-ui/icons/AssessmentOutlined';

import dataProvider from '../../dataProvider';
import './ReductionResults.css';

class ReductionResultsButton extends Component {
  state = {
    showDialog: false,
    showConfirm: false,
    showError: false,
    errorMessage: '',
    reductionType: '',
    percentage: '',
    updatedOrders: [],
    previousTotalRaisedAmount: '',
    updatedTotalRaisedAmount: '',
    editMode: false,
    page: 0,
    perPage: 10,
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ page: 0, perPage: event.target.value });
  };

  clearState = () => {
    this.setState({
      updatedOrders: [],
      previousTotalRaisedAmount: '',
      updatedTotalRaisedAmount: '',
      editMode: false,
    });
  };

  // dialog is the main modal for selecting reduction config
  openDialog = () => {
    this.setState({ showDialog: true });
  };

  closeDialog = () => {
    this.setState({ showDialog: false });
  };

  handleDryRun = async () => {
    try {
      if (this.state.reductionType === '' ||
        (this.state.reductionType === 'percentage' &&
          this.state.percentage === '')) {
        this.setState({ showError: true, errorMessage: 'Please fill out the form' });
        return;
      }
      if (this.state.percentage < 0) {
        this.setState({ showError: true, errorMessage: 'Percentage must be a positive value' });
        return;
      }
      const { resource, record } = this.props;
      this.clearState();
      const { data } = await dataProvider(GET_ONE, 'offerings', {
        action: 'get-reduction-results',
        record,
        resource,
        reductionType: this.state.reductionType,
        percentage: this.state.percentage,
      });
      this.setState({
        updatedOrders: data.result.updatedOrders,
        previousTotalRaisedAmount: data.result.previousTotalRaisedAmount,
        updatedTotalRaisedAmount: data.result.updatedTotalRaisedAmount,
      });
    } catch (err) {
      this.setState({ showError: true, errorMessage: err.message });
      throw err;
    }
  };

  handleSelect = (e) => {
    this.setState({ reductionType: e.target.value });
  };

  handleClear = () => {
    this.setState({
      reductionType: '',
      percentage: '',
      updatedOrders: [],
      previousTotalRaisedAmount: '',
      updatedTotalRaisedAmount: '',
    });
  };

  handlePercentage = (e) => {
    this.setState({ percentage: e.target.value });
  };

  handleApplyReduction = () => {
    this.setState({ showConfirm: true });
  };

  closeConfirm = () => {
    this.setState({ showConfirm: false });
  };

  handleDisagree = () => {
    this.setState({ showConfirm: false });
  };

  handleManualAmountUpdate = (e, index) => {
    const clonedState = Object.assign({}, this.state);
    const updatedOrdersClone = clonedState.updatedOrders;
    updatedOrdersClone[index].requestedTotalCurrencyAmt = e.target.value;
    const updatedTotalAmount = this.calculateUpdatedTotalAmount(updatedOrdersClone);
    this.setState({
      updatedOrders: updatedOrdersClone,
      updatedTotalRaisedAmount: updatedTotalAmount,
    });
  };

  calculateUpdatedTotalAmount = (offerOrders) => {
    let updatedTotalAmount = 0;
    offerOrders.forEach((order) => {
      updatedTotalAmount += parseInt(order.requestedTotalCurrencyAmt, 10);
    });
    return updatedTotalAmount;
  };

  handleConfirm = async () => {
    try {
      const { resource, record } = this.props;
      await dataProvider(UPDATE, 'offerings', {
        action: 'apply-reduction-results',
        record,
        resource,
        reductionType: this.state.reductionType,
        percentage: this.state.percentage,
        updatedOrders: this.state.updatedOrders,
      });
      this.setState({ showConfirm: false, showDialog: false });
      window.location.reload();
    } catch (err) {
      this.setState({ showError: true, errorMessage: err.message });
      throw err;
    }
  };

  render() {
    const { showDialog, showConfirm } = this.state;
    const { ...rest } = this.props;
    const percentageInput = this.state.reductionType === 'percentage' ?
      (
        <div>
          <FormHelperText>Enter percentage</FormHelperText>
          <TextField type="number" value={this.state.percentage} onChange={this.handlePercentage} />
        </div>
      ) :
      null;
    return (
      <Fragment>
        <Button
          onClick={this.openDialog}
          color="primary"
          size="small"
          disabled={this.props.disabled}
        >
          <AssessmentIcon /> Get Reduction Results
        </Button>
        <Dialog fullWidth open={showConfirm} onClose={this.closeConfirm} aria-label="Confirm Reduction">
          <DialogTitle>Confirm Reduction</DialogTitle>
          <DialogContent>
            Do you confirm the reduction? Changes will be effective immediately.
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDisagree} color="primary">Close</Button>
            <Button onClick={this.handleConfirm} color="primary">Confirm</Button>
          </DialogActions>
        </Dialog>
        <Dialog fullWidth maxWidth="md" open={showDialog} onClose={this.closeDialog} aria-label="Get Reduction">
          <DialogTitle>Get Reduction Results</DialogTitle>
          <DialogContent>
            <FormControl>
              <Grid className="grid-container" container spacing={16}>
                <Grid item xs={16}>
                  <FormHelperText>Choose Reduction Type</FormHelperText>
                  <Select
                    native
                    label="Choose Reduction Type"
                    value={this.state.reductionType}
                    onChange={this.handleSelect}
                    input={<Input id="reduction-type" />}
                  >
                    <option value="" />
                    <option value="percentage">Percentage</option>
                    <option value="fcfs">First Come First Serve</option>
                  </Select>
                </Grid>
                <Grid item xs={16}>
                  {percentageInput}
                </Grid>
                <Grid item xs={16}>

                  {
                    this.state.updatedOrders.length !== 0 ?
                      <FormControlLabel
                        control={
                          <Switch checked={this.state.editMode} onChange={() => this.setState({ editMode: !this.state.editMode })} />
                        }
                        label="Trigger manual edit"
                      />
                      : ''
                  }
                </Grid>
              </Grid>
              <Grid className="grid-container" container spacing={16}>
                <Grid item xs={16}>
                  <FormHelperText>
                    Previous Total Raised Amount <span className="previous-label">{this.state.previousTotalRaisedAmount}</span>
                  </FormHelperText>
                </Grid>
                <Grid item xs={16}>
                  <FormHelperText>
                    Updated Total Raised Amount <span className="updated-label">{this.state.updatedTotalRaisedAmount}</span>
                  </FormHelperText>
                </Grid>
              </Grid>
            </FormControl>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Account Number</TableCell>
                  <TableCell>User</TableCell>
                  <TableCell align="right">Previous Amount</TableCell>
                  <TableCell align="right">Updated Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.updatedOrders.slice(this.state.page * this.state.perPage, (this.state.page * this.state.perPage) + this.state.perPage).map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell component="th" scope="row">
                      {row.accountNumber}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.user}
                    </TableCell>
                    <TableCell className="previous-label" align="right">{row.previousRequestedTotalCurrencyAmt}</TableCell>
                    <TableCell className="updated-label" align="right">
                      {
                        this.state.editMode ?
                          <TextField
                            type="number"
                            value={row.requestedTotalCurrencyAmt}
                            onChange={event => this.handleManualAmountUpdate(event, index)}
                          /> : row.requestedTotalCurrencyAmt
                      }
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[]}
                    colSpan={3}
                    count={this.state.updatedOrders.length}
                    rowsPerPage={this.state.perPage}
                    page={this.state.page}
                    SelectProps={{
                      native: true,
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClear} color="secondary" size="small" {...rest}>
              Clear
            </Button>
            <Button onClick={this.handleDryRun} color="secondary" size="small" {...rest}>
              Dry run
            </Button>
            <Button disabled={this.state.updatedOrders.length === 0} onClick={this.handleApplyReduction} color="primary" size="medium">
              Apply Current Reduction Configuration
            </Button>
          </DialogActions>
          <Snackbar
            className="error-message"
            anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
            open={this.state.showError}
            onClose={() => this.setState({ showError: false })}
            message={<span>{this.state.errorMessage}</span>}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={() => this.setState({ showError: false })}
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </Dialog>
      </Fragment>
    );
  }
}

const getReductionResultsAction = (resource, record, meta) => ({
  type: 'GET_REDUCTION_RESULTS',
  payload: {
    record,
    resource,
    action: 'get-reduction-results',
  },
  meta: {
    fetch: GET_ONE,
    resource,
    refresh: true,
    ...meta,
  },
});

ReductionResultsButton.propTypes = {
  record: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  getReductionResults: PropTypes.func.isRequired,
};

export default connect(null, {
  getReductionResults: getReductionResultsAction,
})(ReductionResultsButton);



// WEBPACK FOOTER //
// ./src/components/Offer/ReductionResultsButton.js